import { connect } from 'react-redux';
import React from 'react';
import { Grid } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { getAudioVolume } from '../../../../../utilities/storageUtilities';
import AudioPlaybackTimeline from './AudioPlaybackTimeline';
import AudioPlaybackCounter from './AudioPlaybackCounter';
import { createActions } from '../../store';
import AudioVolumeControl from './AudioVolumeControl';
import AudioPlayPauseButton from './AudioPlayPauseButton';
import { GlobalAudioEventListeners } from '../../Audio/helpers/GlobalAudioEventListeners';
import { DEFAULT_AUDIO_TRACK } from '../../CreatePageConstants';


const styles = theme => ({
    container: {
        height: '100%',
        overflowY: 'hidden',
        overflowX: 'hidden',
        margin: 0,
        width: '100%',
        flexWrap: 'nowrap'
    },
    progressItem: {
        flexGrow: 1,
        minWidth: 0
    }
});

class AudioPlaybackPanel extends React.Component {
    state = {
        canPlay: false,
        dragging: false,
        volume: getAudioVolume()
    }

    render() {
        const { classes, audioUrl, presetsLoading, audioAnalyzing, audioPreparing, savingInProgress } = this.props;
        const { canPlay, volume } = this.state;

        return (
            <Grid
                container
                direction='row'
                alignItems='center'
                spacing={3}
                className={classes.container}
            >
                <Grid>
                    {/* Render the control with play/pause button */}
                    <AudioPlayPauseButton
                        disabled={audioPreparing || presetsLoading || audioAnalyzing || savingInProgress || !canPlay}
                        volume={volume}
                    />
                </Grid>
                <Grid>
                    {/* Render the control for audio volume */}
                    <AudioVolumeControl
                        disabled={audioPreparing || presetsLoading || savingInProgress || audioAnalyzing || !audioUrl || audioUrl == DEFAULT_AUDIO_TRACK.SOUND_URL}
                    />
                </Grid>
                <Grid>
                    {/* Render the counter for audio playback */}
                    <AudioPlaybackCounter canPlay={canPlay} />
                </Grid>
                <Grid
                    className={classes.progressItem}
                >
                    {/* Render the playback slider */}
                    <AudioPlaybackTimeline disabled={!canPlay || presetsLoading || audioAnalyzing || audioPreparing || savingInProgress} />
                </Grid>
            </Grid>
        );
    }

    componentDidMount() {
        // When audio element has enough data to play (can be first few seconds)
        GlobalAudioEventListeners.onCanPlay((event) => {
            this.setState({ canPlay: true });
        });
    }

    componentDidUpdate(prevProps) {
        const { audioUrl, setPlayingPreview } = this.props;
        const { audioUrl: prevAudioUrl } = prevProps;

        if (audioUrl !== prevAudioUrl) {
            setPlayingPreview(false);
        }
    }
}

const mapStateToProps = (state) => {
    const {
        audioAnalyzing,
        presetsLoading,
        audioPreparing
    } = state.create;

    const { url: audioUrl } = state.create.audioSettings;
    const { savingInProgress } = state.create.videoSavingState;

    return {
        audioUrl,
        audioAnalyzing,
        presetsLoading,
        audioPreparing,
        savingInProgress
    }
};

const mapDispatchToProps = (dispatch) => {
    const setPlayingPreview = (playingPreview) => dispatch(createActions.setPlayingPreview(playingPreview));

    return {
        setPlayingPreview
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(AudioPlaybackPanel, styles));